// extracted by mini-css-extract-plugin
export default {"cvError":"I3-z"};